export default {
	navbar: {
		projectId: undefined,
		accountName: undefined,
		path: undefined,
		user: {
			id: 0,
			name: '',
			email: '',
			role: {
				id: 0,
				name: '',
			},
			permissions: []
		},
		isSuperAdmin: false,
		userProjects: [],
		currentUserAccount: {},
		logoUrl: '',
		menuColor: '',
		isFetch: true,
		darkMenu: true,
		unreadMessages: 0,
		showDemo: false,
		isGuest: true,
		isMainDomain: true,
		windowWidth: 0,
		freeTrialNotExpired: undefined,
	}
}
